import React from 'react';
import useTheme from 'branding/theme';
/** used for setting up width and grid; use Section for centering things and adding margin/padding */
/** can be nested infinitely */
const Container = ({ 
/** specify using `fr`s */
gridTemplateRows, 
/**  specify using `fr`s */
gridTemplateColumns, gridColumnGap, gridRowGap, width = 'large', className, styles, children }) => {
    const { sizing } = useTheme();
    const mergedStyles = {
        display: 'grid',
        ...(width && sizing.container[width]),
        gridTemplateColumns,
        ...(gridColumnGap && { gridColumnGap: sizing.component.margin[gridColumnGap] }),
        gridTemplateRows,
        ...(gridRowGap && { gridRowGap: sizing.component.margin[gridRowGap] }),
        ...styles
    };
    return (React.createElement("div", { className: className, style: mergedStyles }, children));
};
export default Container;
//# sourceMappingURL=index.js.map